import { useTranslation } from '@eti/providers';

const useValidationTexts = () => {
  const { t } = useTranslation();
  return {
    cardNumberRequired: t('ValidationMessages.CardNumberIsRequired'),
    cardNumberTooShort: t('ValidationMessages.CardNumberTooShort'),
    cardNumberNotRecognized: t('ValidationMessages.CreditCardNotRecognized'),
    cityRequired: t('ValidationMessages.CityIsRequired'),
    countryRequired: t('ValidationMessages.CountryIsRequired'),
    cvvRequired: t('ValidationMessages.CvvIsRequired'),
    expiryDateRequired: t('ValidationMessages.ExpiryDateIsRequired'),
    firstNameRequired: t('ValidationMessages.FirstNameIsRequired'),
    houseNumberRequired: t('ValidationMessages.HouseNumberIsRequired'),
    inicisCorporateCardRequired: t('ValidationMessages.InicisCorporateCardIsRequired'),
    inicisInvalidCorporateCard: t('ValidationMessages.InicisIncorrectCorporateCard'),
    inicisInvalidPersonalCard: t('ValidationMessages.InicisIncorrectPersonalCard'),
    inicisPersonalCardRequired: t('ValidationMessages.InicisPersonalCardIsRequired'),
    invalidCharacters: t('ValidationMessages.InvalidCharacters'),
    invalidCreditCardNumber: t('ValidationMessages.CreditCardIncorrectNumber'),
    invalidCvv: t('ValidationMessages.CreditCardIncorrectCvcNumber'),
    invalidExpiryDate: t('ValidationMessages.CreditCardIncorrectExpireDate'),
    invalidTaxDateOfBirth: t('ValidationMessages.TaxDateOfBirthIsInvalid'),
    invalidTaxId: t('ValidationMessages.TaxIdIsInvalid'),
    invalidZipCode: t('ValidationMessages.ZipCodeIsInvalid'),
    lastNameRequired: t('ValidationMessages.LastNameIsRequired'),
    required: t('Validation.Required'),
    stateOrProvinceRequired: t('ValidationMessages.StateOrProvinceIsRequired'),
    streetRequired: t('ValidationMessages.StreetIsRequired'),
    taxDateOfBirthRequired: t('ValidationMessages.TaxDateOfBirthIsRequired'),
    taxIdRequired: t('ValidationMessages.TaxIdIsRequired'),
    zipCodeRequired: t('ValidationMessages.ZipCodeIsRequired'),
    invalidUpiCollectId: t('ValidationMessages.IncorrectUpiCollectId'),
  };
};

type ValidationTexts = Record<keyof ReturnType<typeof useValidationTexts>, string>;

export type { ValidationTexts };
export default useValidationTexts;
